/**
 * created by lei lei on 2020/6/30
 * 标题类组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moreImg from "../../desktop/components/commImg/diandiandian.png";

export default class Title extends Component {
    static defaultProps = {showMore: false}
    static propTypes = {
        // title: PropTypes.string.isRequired,//标题
        showMore: PropTypes.bool,//是否显示more
        moreClick: PropTypes.func,//点击查看更多
    }

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div style={{background: 'white', borderRadius: "5px 5px 0px 0px"}}>
                <div style={{
                    height: 43,
                    lineHeight: '60px',
                    background: 'white',
                    width: '100%',
                    float: 'left',
                    borderRadius: "5px 5px 0px 0px"
                }}>
                    <div style={{fontSize: 14, paddingLeft: 20, float: 'left', color: '#333333'}}>
                        {this.props.title}</div>
                    {this.props.showMore ? <div onClick={() => {
                            this.props.moreClick && this.props.moreClick()
                        }} style={{
                            fontSize: 13,
                            right: 0,
                            color: '#0050B3',
                            float: 'right',
                            marginRight: 20,
                            cursor: 'pointer'
                        }}><img src={moreImg} alt=""/></div>
                        : null}
                </div>
                <div style={{clear: 'both'}}/>

            </div>
        )
    }

}